import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  GoogleMap
} from '@react-google-maps/api'
import { MarkerClusterer } from '@googlemaps/markerclusterer'

import { mapOptions } from './data.component'
import { createMarkerSvg } from './map-marker.svg'

const Map = props => {
  const { center, className, locations, mapContainerStyle } = props

  const [map, setMap] = useState(null)
  const markersRef = useRef([])
  const clustererRef = useRef(null)

  const fitBounds = useCallback(map => {
    const bounds = new window.google.maps.LatLngBounds()
    locations.forEach(place => {
      bounds.extend(place)
    })
    map.fitBounds(bounds)
  }, [locations])

  useEffect(() => {
    if (map) {
      fitBounds(map)
    }
  }, [fitBounds, map])

  useEffect(() => {
    if (!map || !locations) return

    // Clean up previous markers
    markersRef.current.forEach(marker => {
      marker.map = null
    })
    markersRef.current = []

    if (clustererRef.current) {
      clustererRef.current.clearMarkers()
    }

    // Create AdvancedMarkerElement for each location
    const markers = locations.map(location => {
      const { color, ...coords } = location

      const content = createMarkerSvg(color)

      return new window.google.maps.marker.AdvancedMarkerElement({
        position: coords,
        content
      })
    })

    markersRef.current = markers

    // Create or update clusterer
    if (clustererRef.current) {
      clustererRef.current.addMarkers(markers)
    } else {
      clustererRef.current = new MarkerClusterer({
        map,
        markers
      })
    }

    return () => {
      markers.forEach(marker => {
        marker.map = null
      })
    }
  }, [map, locations])

  const loadHandler = m => {
    setMap(m)
  }

  return (
    <div className={className}>
      <GoogleMap
        center={center}
        mapContainerStyle={mapContainerStyle}
        onLoad={loadHandler}
        options={mapOptions}
      >
        {null}
      </GoogleMap>
    </div>
  )
}

export default Map
